/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : TicketTestCaseArtifact.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { componentStyle } from "../../../config/appTheme";
import CustomTabsV2 from "../../../components/customComponentsV2/common/tabs/CustomTabsV2";
import ViewTestCaseArtifact from "./ViewTestCaseArtifact";
import AddTestCaseArtifact from "./AddTestCaseArtifact";

function TicketTestCaseArtifact({
  selectedTicketsTableRowData,
  setSelectedTicketsTableRowData,
  onClose,
  fetchTickets,
  displayAddArtifact,
}) {
  return (
    <Box>
      <Grid container>
        <Grid item sm={12} sx={{ textAlign: "center" }}>
          <Typography sx={{ ...componentStyle.font.cardHeadder }}>
            Test Case Artifact
          </Typography>
        </Grid>
        <Grid item sm={12}>
          <CustomTabsV2
            centerTabs={true}
            tabs={[
              {
                name: "View",
                count: "",
                content: (
                  <ViewTestCaseArtifact
                    onClose={onClose}
                    selectedTicketsTableRowData={selectedTicketsTableRowData}
                    setSelectedTicketsTableRowData={
                      setSelectedTicketsTableRowData
                    }
                  />
                ),
              },
              ...(displayAddArtifact
                ? [
                    {
                      name: "Add",
                      count: "",
                      content: (
                        <>
                          {selectedTicketsTableRowData &&
                          Object.keys(selectedTicketsTableRowData).length >
                            0 ? (
                            <AddTestCaseArtifact
                              onClose={onClose}
                              selectedTicketsTableRowData={
                                selectedTicketsTableRowData
                              }
                              setSelectedTicketsTableRowData={
                                setSelectedTicketsTableRowData
                              }
                              fetchTickets={fetchTickets}
                            />
                          ) : (
                            <Typography sx={{ textAlign: "center", p: 2 }}>
                              No ticket data selected
                            </Typography>
                          )}
                        </>
                      ),
                    },
                  ]
                : []),
            ]}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

TicketTestCaseArtifact.propTypes = {
  selectedTicketsTableRowData: PropTypes.object,
  setSelectedTicketsTableRowData: PropTypes.func,
  onClose: PropTypes.func,
  fetchTickets: PropTypes.func,
  displayAddArtifact: PropTypes.bool,
};

export default TicketTestCaseArtifact;
